import {integrationRequestContext, IntegrationMessageStatus, IntegrationRequestErrors, submitIntegrationRequest} from "./integrationRequest";

// A lost response must not automatically submit another physical print job.
export const deliveryNoteRequestContext = integrationRequestContext;

const DELIVERY_NOTE_ERRORS: IntegrationRequestErrors = {
   notSubmitted: 'Delivery note request was not submitted. Check the delivery note connector configuration.',
   failed: 'Delivery note printing failed. Check the integration message before retrying.',
   ignored: 'Delivery note printing was ignored by the connector.',
   timedOut: 'Printing has not been confirmed. Check the printer and integration message before retrying.'
};

/** Submits a delivery note print request for the order and resolves once the connector confirms printing. */
export const printDeliveryNote = (
   orderId: string,
   request: (orderId: string, signal: AbortSignal) => Promise<string[] | null | undefined>,
   readStatus: (tokens: string[], signal: AbortSignal) => Promise<(IntegrationMessageStatus | null)[] | null | undefined>
): Promise<void> => submitIntegrationRequest(signal => request(orderId, signal), readStatus, DELIVERY_NOTE_ERRORS);
